import AddGoalEvent from "./GoalEvent/AddGoalEvent";
import AddCardEvent from "./CardEvent/AddCardEvent";
import AddPenaltyEvent from "./PenaltyEvent/AddPenaltyEvent";
import EditCardEvent from "./CardEvent/EditCardEvent";
import EditGoalEvent from "./GoalEvent/EditGoalEvent";
import AddEventNotes from "./EventNotes/AddEventNotes";
import EditEventNotes from "./EventNotes/EditEventNotes";
import AddCornerEvent from "./CornerEvent/AddCornerEvent";
import EditCornerEvent from "./CornerEvent/EditCornerEvent";
import EditPenaltyEvent from "./PenaltyEvent/EditPenaltyEvent";
import EditShootoutEvent from "./ShootoutEvent/EditShootoutEvent";

const TOTAL_QUARTER_TIME = 900;

const commonParams = {
    totalTime: TOTAL_QUARTER_TIME,
    hasEndMatchButton: false,
    quarterStopped: true,
    quarterStarted: false,
    quarterEnded: false,
};

const EVENT_TYPES = [
    {
        name: "GRÜN",
        background: "#007836",
        addComponentToOpen: AddCardEvent,
        editComponentToOpen: EditCardEvent,
    },
    {
        name: "GELB",
        background: "#F8D200",
        addComponentToOpen: AddCardEvent,
        editComponentToOpen: EditCardEvent,
    },
    {
        name: "ROT",
        background: "#FF0014",
        addComponentToOpen: AddCardEvent,
        editComponentToOpen: EditCardEvent,
    },
    {
        name: "GOAL",
        background: "#006DFF",
        width: "45%",
        addComponentToOpen: AddGoalEvent,
        editComponentToOpen: EditGoalEvent,
    },
    {
        name: "PS",
        background: "#5B5B5B",
        width: "20%",
        addComponentToOpen: AddPenaltyEvent,
        editComponentToOpen: EditPenaltyEvent,
    },
    {
        name: "PC",
        background: "#5B5B5B",
        width: "20%",
        addComponentToOpen: AddCornerEvent,
        editComponentToOpen: EditCornerEvent,
    },
    {
        name: "COMMENT",
        background: "#595959",
        addComponentToOpen: AddEventNotes,
        editComponentToOpen: EditEventNotes,
    },
    {
        name: "GELB ROT",
        background:
            "linear-gradient(-45deg, rgb(255, 0, 20) 50%, rgb(248, 210, 0) 50%)",
        addComponentToOpen: AddCardEvent,
        editComponentToOpen: EditCardEvent,
    },
];

const GOAL_TYPES = [
    {
        id: 0,
        name: "Feld",
    },
    {
        id: 1,
        name: "Ecke",
    },
    {
        id: 2,
        name: "7 Meter",
    },
];

const PS_TYPES = [
    {
        id: 0,
        name: "Daneben",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 1,
        name: "Treffer",
        backgroundColor: "#006DFF",
        color: "#fff",
        borderColor: "#006DFF",
    },
];

const PC_CORNERGOAL_TYPES = [
    {
        id: 0,
        name: "Direkter Schuss",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 1,
        name: "Stecher",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 2,
        name: "Variante",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 3,
        name: "Rebound",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 4,
        name: "Penalty Corner",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
];

const REASONS_FOR_CARDS = [
    {
        id: 0,
        name: "Foulspiel",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 1,
        name: "unsportliches Verhalten",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 2,
        name: "Sonstiges",
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
];

const TIME_SUSPENSION_FOR_CARDS = [
    {
        id: 0,
        name: "1 Min",
        minutes: 1,
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 1,
        name: "2 Mins",
        minutes: 2,
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 2,
        name: "5 Mins",
        minutes: 5,
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 3,
        name: "10 mins",
        minutes: 10,
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
    {
        id: 4,
        name: "15 mins",
        minutes: 15,
        backgroundColor: "white",
        color: "black",
        borderColor: "black",
    },
];

const ALLOWED_MINUTES_BY_CARD = {
    GELB: [2, 5, 10, 15],
    GRÜN: [1, 2],
};

const initSides = {
    home: {
        id: 0,
        side: "home",
        teamName: "THK Rissen",
        teamColor: "#86B99D",
        players: [
            {
                playerNumber: 1,
                playerName: "Knutzen, Leoni",
            },
            {
                playerNumber: 2,
                playerName: "Grunau, Nelly",
            },
            {
                playerNumber: 5,
                playerName: "Lück, Natalie",
            },
        ],
    },
    away: {
        id: 1,
        side: "away",
        teamName: "Klipper THC 2",
        teamColor: "#BDD3F1",
        players: [
            {
                playerNumber: 4,
                playerName: "Johe, Lena",
            },
            {
                playerNumber: 8,
                playerName: "Stuhlmann, Friedericke",
            },
            {
                playerNumber: 13,
                playerName: "Heins, Almut",
            },
        ],
    },
};

const initQuarters = {
    Q1: {
        id: "Q1",
        timePlayed: 0,
        timeLeft: null,
        ...commonParams,
    },

    Q2: {
        id: "Q2",
        timePlayed: 0,
        timeLeft: null,
        ...commonParams,
    },
    Q3: {
        id: "Q3",
        timePlayed: 0,
        timeLeft: null,
        ...commonParams,
    },
    Q4: {
        id: "Q4",
        timePlayed: 0,
        timeLeft: null,
        ...commonParams,
    },
    SO: {
        id: "SO",
        timePlayed: 0,
        timeLeft: 900,
        ...commonParams,
    },
};

// Not in EVENT_TYPES: a shootout is started by ending the last period, never
// added from the side panel
const SHOOTOUT_EVENT = {
    name: "SHOOTOUT",
    editComponentToOpen: EditShootoutEvent,
};

export {
    EVENT_TYPES,
    SHOOTOUT_EVENT,
    GOAL_TYPES,
    PS_TYPES,
    PC_CORNERGOAL_TYPES,
    REASONS_FOR_CARDS,
    TIME_SUSPENSION_FOR_CARDS,
    ALLOWED_MINUTES_BY_CARD,
    initSides,
    initQuarters,
};
